// Used to parse and fix a URL that has duplicate query parameters
export function parseAndFixUrl(url: string): string {
  // Split the URL by '?'
  const parts = url.split("?");
  const baseUrl = parts[0];

  // Combine all query parameters
  const queryString = parts.slice(1).join("&");

  // Parse the query string
  const params = new URLSearchParams(queryString);

  // Remove duplicates while preserving order
  const uniqueParams = new URLSearchParams();
  params.forEach((value, key) => {
    if (!uniqueParams.has(key)) {
      uniqueParams.append(key, value);
    }
  });

  // Reconstruct the URL
  const newQueryString = uniqueParams.toString();
  const fixedUrl = newQueryString ? `${baseUrl}?${newQueryString}` : baseUrl;

  return fixedUrl;
}
